/**
 * Shared Front Dashboard bundle
 * Used by both companies_dash and partners
 * Loaded as a separate webpack entry point
 */

// Import the CSS
import '../../sass/shared/front_dashboard.scss'

// Import Bootstrap and dependencies
import '@popperjs/core'
import 'bootstrap'
import 'bootstrap/js/dist/dropdown'

// Import vendor libraries
import TomSelect from 'tom-select/dist/js/tom-select.complete.min.js'
import Dropzone from 'dropzone'

window.TomSelect = TomSelect
window.Dropzone = Dropzone

// Import Front Dashboard JS
import './front_dashboard/theme-custom'
import './front_dashboard/hs.core'
import './front_dashboard/hs.theme-appearance'
import './front_dashboard/hs.tom-select'
import './front_dashboard/hs.chartjs'
import './front_dashboard/hs.dropzone'

import HSAddField from './front_dashboard/hs-add-field'
window.HSAddField = HSAddField

import HSStepForm from './front_dashboard/hs-step-form'
window.HSStepForm = HSStepForm

export { TomSelect, Dropzone, HSAddField, HSStepForm }
